import React from 'react';

import { Anchor, TextButton } from '@zillow/constellation';
import type { LinkProps } from '../../../../interfaces/linkProps';

interface Props {
  title?: string;
  className?: string;
  children: React.ReactNode;
  path: string;
  escape?: boolean;
  useAbsolutePaths?: boolean;
  // Link component from react-router or next.js
  link?: React.ComponentType<React.PropsWithChildren<LinkProps>>;
}

const HeaderButton = ({ title, className, children, path, escape = false, useAbsolutePaths, link }: Props) => {
  if (!useAbsolutePaths && !escape && link) {
    return (
      // @ts-ignore issue with the component children
      <TextButton
        // @ts-ignore issue with the link interface
        as={link}
        title={title}
        className={className}
        to={path}
      >
        {children}
      </TextButton>
    );
  }

  return (
    <TextButton title={title} className={className} as={Anchor} href={path}>
      {children}
    </TextButton>
  );
};

export default HeaderButton;
